import {createGlobalStyle} from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  //background-color: rgb(15 23 42/var(--tw-bg-opacity));
  //linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,133,0.7371323529411764) 82%, rgba(0,212,255,1) 100%)
  :root {
    --dark-bg: #262626;
    --gray-1: #BCB4B4;
    --gray-2: #363636;
    --gray-3: #544624;;
    --gray-error: red;
    --deep-dark: #1E1E1E;
    --white: white;
    --black: black;
  }

  html {
    //overflow: hidden;
    &::-webkit-scrollbar {
      width: 0;
    }

    font-size: 10px;
    font-family: 'Roboto Mono', sans-serif;
    background-image: linear-gradient(45deg,
    hsl(0deg 0% 16%) 0%,
    hsl(344deg 0% 16%) 13%,
    hsl(344deg 0% 16%) 25%,
    hsl(344deg 0% 16%) 37%,
    hsl(344deg 0% 16%) 50%,
    hsl(344deg 0% 16%) 63%,
    hsl(344deg 0% 16%) 75%,
    hsl(344deg 0% 16%) 87%,
    hsl(0deg 0% 16%) 100%);

    background-size: 200% 110%;
    //animation: gradient 10s ease infinite;


    @keyframes gradient {

      0% {
        background-position: 0 50%;
      }

      50% {
        background-position: 100% 50%;
      }

      100% {
        background-position: 0 50%;
      }

    }

  }


  ul, li {
    list-style: none;
  }

  a {
    text-decoration: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  svg {
    width: 100%;
    height: 200%;
    object-fit: cover;


    @media only screen and (max-width: 1024px) {
      body {
        overflow: scroll !important;
      }

      width: 100%;
      object-fit: cover;
    }


    @media only screen and (max-width: 768px) {
      width: 100%;
      object-fit: cover;
    }
    @media only screen and (max-width: 320px) {
      width: 122%;
      object-fit: cover;
    }
  }


  button {
    outline: none
  }

  .container {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
  }


  /* Smooth Scroll  */
  [data-scrollbar] {
    height: 100vh;
    overflow: hidden;
    background-color: var(--gray-1);

    .scroll-content {
      background-color: var(--dark-bg);
    }

    .scrollbar-track.scrollbar-track-y {
      background: var(--deep-dark);

      .scrollbar-thumb-y {
        background: var(--gray-1);
      }
    }
  }
`;
export default GlobalStyles;
